import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Ablauf } from './pages/Ablauf';
import { AboutMe } from './pages/AboutMe';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f8n9p58z6n28">
      <ScrollToTop data-id="element-1" data-mp="2rkdw2qlx15m6" />
      <Routes data-id="element-2" data-mp="2rlyrsjjyuulm">
        <Route path="/" element={<Home data-id="element-4" data-mp="2rit2p4bc7spw" />} data-id="element-3" data-mp="2rlf8ayeo3y5h" />
        <Route path="/ablauf" element={<Ablauf data-id="element-6" data-mp="2mmlv773am95u" />} data-id="element-5" data-mp="2mlubatj25zve" />
        <Route path="/about-me" element={<AboutMe data-id="element-8" data-mp="2mjzlb0sxjhkg" />} data-id="element-7" data-mp="2mndq0fp2g2v2" />
        <Route path="/impressum" element={<Impressum data-id="element-10" data-mp="31bibfrfi6shj" />} data-id="element-9" data-mp="31agpgrwy8ll1" />
        <Route path="/datenschutz" element={<Datenschutz data-id="element-12" data-mp="2wka1mua9h53u" />} data-id="element-11" data-mp="31c1iue7j1yhb" />
      </Routes>
    </BrowserRouter>;
}